const getDefaultState = () => {
  return {
    plans: [],
    plan: null,
    loading: false,
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};
